import { FaqContactForm } from "commonAssets/pages/FaqContactForm";

/**
 * Mode of the app to surface current environment
 */
export const mode = process.env.mode;

/**
 * The version of the application.
 * @type {string}
 */
export const appVersion = process.env.appVersion;

/**
 * API key for AWS endpoint.
 * @type {string}
 */
export const appConfigKey = process.env.appConfigKey;

/**
 * Production API gateway.
 * @type {string}
 */
export const appConfigProd = process.env.appConfigProd;

/**
 * Development API gateway.
 * @type {string}
 */
export const appConfigDev = process.env.appConfigDev;

/**
 * Hostname of the app.
 * @type {string[]}
 */
export const appHost = window.location.host.split(".");

/**
 * App docket, domain name listed on CMS.
 * @example www.examplesite.com
 * @type {string}
 */
export const appDocket = process.env.appDocket;

/**
 * API endpoint for app docket.
 * @type {string}
 */
export const appDocketAPI =
    appConfigProd + "/website?domain=" + appDocket + "&active=true";

/**
 * Path to the app claim form.
 * @type {string}
 */
export const appClaimForm = "./docs/formDefault.json";

/**
 * reCAPTCHA v3 key.
 * @type {string}
 */
export const reCAPTCHAv3 = process.env.reCAPTCHAv3;

/**
 * Digital Disbursements case specific API key.
 * @type {string}
 */
export const appPayMethod = process.env.appPayMethod;

/**
 * Duration for the cookie (in days).
 * @type {number}
 */
export const cookieDuration = process.env.cookieDuration;

/**
 * Post claim method.
 * @type {string}
 */
export const claimMethod = process.env.claimMethod;

/**
 * The domain of the application.
 * @type {string}
 */
export const appDomain = process.env.appDomain;

/**
 * Output <div> element.
 * @type {HTMLElement}
 */
export const outputDiv = document.getElementById("output");

/**
 * Loading element.
 * @type {HTMLElement}
 */
export const loading = document.getElementById("loading");

/**
 * Available languages.
 * @type {any}
 */
export const languages = process.env.languages;

/**
 * Claim guard element.
 * @type {HTMLElement}
 */
export const claimGuard = document.getElementById("guard");

/**
 * Claim confirmation element.
 * @type {HTMLElement}
 */
export const claimConfirm = document.getElementById("confirmation");

/**
 * Claim form element.
 * @type {HTMLElement}
 */
export const claimForm = document.getElementById("form");

/**
 * Information about the site.
 * @type {any}
 */
export let siteInfo,
    emailConfirm,
    siteInfoLang,
    emailInform,
    phoneAdmin,
    userLanguage,
    appLocale,
    i18n,
    faqContactForm;

/**
 * Set the i18n object.
 * @param {function} callback - A callback function that returns the i18n object.
 */
export function setI18n(callback) {
    i18n = callback();
}

/**
 * Set the siteInfoLang value.
 * @param {function} callback - A callback function that returns the siteInfoLang value.
 */
export function setSiteInfoLang(callback) {
    siteInfoLang = callback();
}

/**
 * Set the siteInfo value.
 * @param {function} callback - A callback function that returns the siteInfo value.
 */
export function setSiteInfo(callback) {
    siteInfo = callback();
}

/**
 * Set the emailConfirm value.
 * @param {function} callback - A callback function that returns the emailConfirm value.
 */
export function setEmailConfirm(callback) {
    emailConfirm = callback();
}

/**
 * Set the emailInform value.
 * @param {function} callback - A callback function that returns the emailInform value.
 */
export function setEmailInform(callback) {
    emailInform = callback();
}

/**
 * Set the phoneAdmin value.
 * @param {function} callback - A callback function that returns the phoneAdmin value.
 */
export function setPhoneAdmin(callback) {
    phoneAdmin = callback();
}

/**
 * Set the userLanguage value.
 * @param {function} callback - A callback function that returns the userLanguage value.
 */
export function setUserLanguage(callback) {
    userLanguage = callback();
}

/**
 * Set the appLocale value and update the language of the document element.
 * @param {function} callback - A callback function that returns the appLocale value.
 */
export function setAppLocale(callback) {
    appLocale = callback();
    document.documentElement.lang = appLocale;
}

/**
 * Set the faqContactForm as an instance of FaqContactForm and initialize it.
 */
export function setContactFAQPage() {
    faqContactForm = new FaqContactForm();
    faqContactForm.init();
}
